(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cotigo-shipping-bar"] && !Shopify.designMode) return;
  try {
    
function calculate(cart, region) {
  if (!region) return {state:'choose', remaining:null};
  if (!cart || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0) return {state:'unavailable', remaining:null};
  if (cart.currency !== 'EUR' || !Number.isSafeInteger(region.threshold) || region.threshold < 0) return {state:'unavailable', remaining:null};
  if (cart.item_count > 0 && !cart.requires_shipping) return {state:'digital', remaining:null};
  const remaining = Math.max(0, region.threshold - cart.total_price);
  return {state:cart.item_count === 0 ? 'empty' : remaining ? 'remaining' : 'reached', remaining};
}


class CotigoShippingBar extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.config = JSON.parse(this.querySelector('[data-config]').textContent);
    if (this.classList.contains('csb-cart')) {
      const headerConfig = document.querySelector('cotigo-shipping-bar:not(.csb-cart) [data-config]');
      if (headerConfig) this.config.threshold = JSON.parse(headerConfig.textContent).threshold;
    }
    this.message = this.querySelector('[data-message]');
    this.progress = this.querySelector('[data-progress]');
    this.sequence = 0;
    this.onCart = event => {
      this.progress.style.transform = 'scaleX(0)';
      this.cart = null;
      this.sequence++;
      this.message.textContent = this.config.text.loading;
      Promise.resolve(event.promise).then(() => this.refresh(), () => this.refresh());
    };
    ['shopify:cart:lines-update','shopify:cart:discount-update','shopify:cart:view','cart-section:restored'].forEach(name => document.addEventListener(name,this.onCart,{signal:this.controller.signal}));
    window.addEventListener('pageshow', () => this.refresh(), {signal:this.controller.signal});
    document.addEventListener('visibilitychange', () => {if (!document.hidden) this.refresh();}, {signal:this.controller.signal});
    this.refresh();
  }
  disconnectedCallback() {
    this.sequence++;
    this.controller?.abort();
    this.request?.abort();
    this.controller = null;
  }
  async refresh() {
    const sequence = ++this.sequence;
    this.request?.abort();
    this.request = new AbortController();
    try {
      const response = await fetch(this.config.cartUrl, {cache:'no-store',credentials:'same-origin',signal:this.request.signal});
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (sequence !== this.sequence || !this.isConnected) return;
      this.cart = cart;
      this.render();
    } catch (error) {
      if (sequence !== this.sequence || error.name === 'AbortError') return;
      this.cart = null;
      this.message.textContent = this.config.text.unavailable;
    }
  }
  render() {
    this.message = this.querySelector('[data-message]');
    this.progress = this.querySelector('[data-progress]');
    const region = {threshold:this.config.threshold};
    const result = calculate(this.cart, region);
    const valid = ['empty','remaining','reached'].includes(result.state);
    const ratio = valid ? (region.threshold > 0 ? Math.min(1, Math.max(0, this.cart.total_price / region.threshold)) : (result.state === 'reached' ? 1 : 0)) : 0;
    this.progress.style.transform = `scaleX(${ratio})`;
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'es', {style:'currency',currency:'EUR'}).format(value/100);
    this.message.textContent = this.config.text[result.state].replace('[amount]',money(result.remaining ?? region?.threshold ?? 0)).replace('[region]',region?.name || '');
  }
}
if (!customElements.get('cotigo-shipping-bar')) customElements.define('cotigo-shipping-bar',CotigoShippingBar);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cotigo-theme-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cotigo-theme-stories')) {
  customElements.define('cotigo-theme-stories', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const surface = this.querySelector('.cotigo-stories__panels');
      const panels = [...this.querySelectorAll('.cotigo-stories__panel')];
      const range = this.querySelector('input');
      const nav = this.querySelector('.cotigo-stories__nav');
      const segments = [...this.querySelectorAll('.cotigo-stories__rail span')];
      if (!panels.length) return;
      const reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
      let current = -1;
      let start;
      let lastSwipe = 0;
      let desiredScroll = 0;
      const clamp = index => Math.max(0, Math.min(panels.length - 1, index));
      const setActive = (index, focus = false) => {
        const next = clamp(index);
        if (next === current) return;
        if (current >= 0 && panels[current].contains(document.activeElement)) focus = true;
        current = next;
        panels.forEach((panel, i) => {
          panel.toggleAttribute('data-active', i === current);
          panel.setAttribute('aria-hidden', String(i !== current));
          panel.inert = i !== current;
        });
        segments.forEach((segment, i) => segment.toggleAttribute('data-active', i === current));
        range.value = current + 1;
        range.setAttribute('aria-valuetext', panels[current].getAttribute('aria-label'));
        if (focus) range.focus({ preventScroll: true });
      };
      let snapping = false;
      const cancelSnap = () => {
        cancelAnimationFrame(this.snapFrame);
        this.snapFrame = null;
        snapping = false;
        clearTimeout(this.settleTimer);
      };
      const goTo = (index, force = false) => {
        const next = clamp(index);
        if (next === current && !force) return;
        cancelSnap();
        setActive(next);
        const from = surface.scrollLeft;
        const left = next * surface.clientWidth;
        const began = performance.now();
        const duration = reducedMotion.matches ? 0 : 220;
        snapping = true;
        surface.setAttribute('data-mouse-scrolling', '');
        const frame = now => {
          const progress = duration ? Math.min(1, (now - began) / duration) : 1;
          surface.scrollTo({ left: from + (left - from) * (1 - (1 - progress) ** 3), behavior: 'instant' });
          if (progress < 1) this.snapFrame = requestAnimationFrame(frame);
          else {
            this.snapFrame = null;
            snapping = false;
            surface.removeAttribute('data-mouse-scrolling');
          }
        };
        this.snapFrame = requestAnimationFrame(frame);
      };
      let wheelGesture;
      const finishWheel = () => {
        if (!wheelGesture || wheelGesture.locked) return;
        const moved = surface.scrollLeft - wheelGesture.origin;
        wheelGesture.locked = true;
        const advance = Math.abs(moved) >= Math.min(80, surface.clientWidth * 0.12);
        goTo(wheelGesture.index + (advance ? Math.sign(moved) : 0), true);
      };
      surface.addEventListener('wheel', event => {
        if (event.ctrlKey || Math.abs(event.deltaY) >= Math.abs(event.deltaX) || !event.cancelable) return;
        event.preventDefault();
        surface.setAttribute('data-wheel-controlled', '');
        const now = performance.now();
        const unit = event.deltaMode === 1 ? 16 : event.deltaMode === 2 ? surface.clientWidth : 1;
        const delta = event.deltaX * unit;
        const magnitude = Math.abs(delta);
        const direction = Math.sign(delta);
        const previous = wheelGesture;
        const fresh = !previous || now - previous.at > 160 || direction !== previous.direction || (previous.locked && magnitude > Math.max(12, previous.magnitude * 2.5));
        if (fresh) {
          cancelSnap();
          wheelGesture = { origin: surface.scrollLeft, index: Math.round(surface.scrollLeft / surface.clientWidth), direction, magnitude, at: now, slowing: 0, locked: false };
        }
        const gesture = wheelGesture;
        const slowing = magnitude < gesture.magnitude * 0.92;
        gesture.slowing = slowing ? gesture.slowing + 1 : 0;
        gesture.at = now;
        gesture.magnitude = magnitude;
        clearTimeout(this.wheelTimer);
        if (gesture.locked) return;
        surface.setAttribute('data-mouse-scrolling', '');
        const max = (panels.length - 1) * surface.clientWidth;
        surface.scrollTo({ left: Math.max(0, Math.min(max, surface.scrollLeft + delta)), behavior: 'instant' });
        const moved = Math.abs(surface.scrollLeft - gesture.origin);
        if ((gesture.slowing >= 2 && moved >= 32) || moved >= surface.clientWidth * 0.5 || reducedMotion.matches) finishWheel();
        else this.wheelTimer = setTimeout(finishWheel, 32);
      }, { ...options, passive: false });
      const settle = () => {
        if (start || snapping || (wheelGesture && !wheelGesture.locked)) return;
        clearTimeout(this.settleTimer);
        setActive(Math.round(surface.scrollLeft / surface.clientWidth));
        surface.removeAttribute('data-mouse-scrolling');
      };
      surface.addEventListener('scroll', () => {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(settle, 120);
      }, { ...options, passive: true });
      surface.addEventListener('scrollend', settle, options);
      range.setAttribute('aria-orientation', 'horizontal');
      range.addEventListener('input', () => goTo(Number(range.value) - 1), options);
      const gestureAxis = (dx, dy) => Math.max(Math.abs(dx), Math.abs(dy)) < 10 ? null : Math.abs(dy) >= Math.abs(dx) ? "y" : Math.abs(dx) > Math.abs(dy) * 1.25 ? "x" : null;
      let railGesture;
      const fromPointer = (event, box) => goTo(Math.floor((event.clientX - box.left) / box.width * panels.length));
      nav.addEventListener('pointerdown', event => {
        if (event.button !== 0 || !event.isPrimary) return;
        railGesture = { id: event.pointerId, x: event.clientX, y: event.clientY, axis: null, box: nav.getBoundingClientRect() };
      }, options);
      nav.addEventListener('pointermove', event => {
        if (railGesture?.id !== event.pointerId) return;
        railGesture.axis ||= gestureAxis(event.clientX - railGesture.x, event.clientY - railGesture.y);
        if (railGesture.axis === 'y') { railGesture = null; return; }
        if (railGesture.axis === 'x') {
          nav.setPointerCapture(event.pointerId);
          fromPointer(event, railGesture.box);
        }
      }, options);
      nav.addEventListener('pointerup', event => {
        if (railGesture?.id !== event.pointerId) return;
        const box = railGesture.box;
        railGesture = null;
        fromPointer(event, box);
        if (nav.hasPointerCapture(event.pointerId)) nav.releasePointerCapture(event.pointerId);
      }, options);
      nav.addEventListener('pointercancel', () => { railGesture = null; }, options);
      nav.addEventListener('lostpointercapture', () => { railGesture = null; }, options);
      // Touch uses native horizontal scrolling; custom dragging is mouse-only.
      surface.addEventListener('pointerdown', event => {
        clearTimeout(this.wheelTimer);
        wheelGesture = null;
        cancelSnap();
        if (event.pointerType !== 'mouse') {
          surface.removeAttribute('data-mouse-scrolling');
          surface.removeAttribute('data-wheel-controlled');
        }
        if (event.pointerType !== 'mouse' || event.button !== 0 || !event.isPrimary || event.target.closest('button,input')) return;
        start = { id: event.pointerId, x: event.clientX, y: event.clientY, scroll: surface.scrollLeft, width: surface.clientWidth, index: current, axis: null };
        event.preventDefault();
      }, options);
      surface.addEventListener('dragstart', event => event.preventDefault(), options);
      surface.addEventListener('pointermove', event => {
        if (!start || event.pointerId !== start.id) return;
        const dx = event.clientX - start.x;
        const dy = event.clientY - start.y;
        if (!start.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 10) start.axis = Math.abs(dx) > Math.abs(dy) * 1.25 ? 'x' : 'y';
        if (start.axis !== 'x') return;
        if (!surface.hasPointerCapture(event.pointerId)) surface.setPointerCapture(event.pointerId);
        surface.setAttribute('data-dragging', '');
        surface.setAttribute('data-mouse-scrolling', '');
        desiredScroll = start.scroll - dx;
        if (this.dragFrame == null) this.dragFrame = requestAnimationFrame(() => {
          this.dragFrame = null;
          if (start?.axis === 'x') surface.scrollLeft = desiredScroll;
        });
      }, options);
      const finishDrag = event => {
        if (!start || (event && event.pointerId !== start.id)) return;
        const gesture = start;
        start = null;
        cancelAnimationFrame(this.dragFrame);
        this.dragFrame = null;
        surface.removeAttribute('data-dragging');
        if (gesture.axis === 'x') {
          surface.scrollLeft = desiredScroll;
          const dx = event ? event.clientX - gesture.x : 0;
          const advance = Math.abs(dx) > Math.min(80, gesture.width * 0.12);
          goTo(gesture.index + (advance ? (dx < 0 ? 1 : -1) : 0), true);
          lastSwipe = Date.now();
        } else if (surface.hasAttribute('data-mouse-scrolling')) {
          goTo(Math.round(surface.scrollLeft / surface.clientWidth), true);
        }
      };
      surface.addEventListener('pointerup', finishDrag, options);
      surface.addEventListener('pointercancel', () => finishDrag(), options);
      surface.addEventListener('lostpointercapture', () => finishDrag(), options);
      surface.addEventListener('click', event => {
        if (Date.now() - lastSwipe < 400) event.preventDefault();
      }, { ...options, capture: true });
      document.addEventListener('shopify:block:select', event => {
        const index = panels.findIndex(panel => panel.dataset.block === event.detail.blockId && this.contains(event.target));
        if (index >= 0) goTo(index);
      }, options);
      this.imageObserver = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.querySelectorAll('img').forEach(image => {
          image.loading = 'eager';
          image.decoding = 'async';
          image.decode().catch(() => {});
        });
        this.imageObserver.disconnect();
      }, { rootMargin: '100% 0px' });
      this.imageObserver.observe(this);
      setActive(0);
      this.setAttribute('data-ready', '');
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.imageObserver?.disconnect();
      clearTimeout(this.settleTimer);
      clearTimeout(this.wheelTimer);
      cancelAnimationFrame(this.dragFrame);
      cancelAnimationFrame(this.snapFrame);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
